import { createIconSetFromIcoMoon } from '@expo/vector-icons';
import advanceFeatureIconConfig from './config.json';
const AdvanceFeatureIcon = createIconSetFromIcoMoon(advanceFeatureIconConfig, 'AdvanceFeatureIcon', 'Advance-Feature-Icon.ttf');
export default AdvanceFeatureIcon;
//# sourceMappingURL=index.js.map